import Post from "../Post";

export default function userActivation(token, otp) {
  return Post("user/activation", {
    temporaryToken: token,
    otp: otp,
  });
}
